import React from 'react';
import {Router, Route,Switch} from 'react-router-dom'
import Agreements from './pages/agreements'
import Video from './pages/video'
import DAgreements from './pages/dance/agreements'
import DPrivacy from './pages/dance/privacy'
import Privacy from './pages/privacy'
import Download from './pages/download'
import Main from './pages/main'
import Share from './pages/share'
import Preview from './pages/preview'
import {createBrowserHistory} from "history"
import MediaQuery from 'react-responsive'
import {Col,Row ,Layout} from 'antd';
const { Header, Footer, Sider, Content } = Layout;
const PCVideo = props =>{
  const [h,setH] = React.useState(0)
  React.useEffect(()=>{
    setH(window.innerHeight)
  },[])
  return <Layout style={{backgroundColor:'white',height:h}}>
          <Header style={{backgroundColor:'white'}}></Header>
          <Row style={{backgroundColor:'white'}}>
            <Col span={8}>
            </Col>
            <Col span={8}>
              <Video></Video>
            </Col>
            <Col span={8}>
            </Col>
        </Row>
        </Layout>
}

const AppVideo = props =>{
  return <Row>
    <Col span={0}>
    </Col>
    <Col span={24}>
      <Video></Video>
    </Col>
    <Col span={0}>
    </Col>
  </Row>
}
const browserHistory = createBrowserHistory();
export default class App extends React.Component
{
  render()
  {
    return  <div>
         <MediaQuery query='(min-device-width:1224px)'>
            <Router history = {browserHistory}>
                <Switch>
                  <Route exact path="/" component={()=><Main/>}/>
                  <Route exact path="/privacy/" component={Privacy}/>
                  <Route  path="/agreements/" component={Agreements}/>
                  <Route  path="/video/:prefix?/" component={PCVideo}/>
                  <Route  path="/dance/agreements/" component={DAgreements}/>
                  <Route path="/dance/privacy/" component={DPrivacy}/>
                  <Route  path="/download/:idcode?/" component={Download}/>
                  <Route  path="/share/:idcode?/" component={Share}/>
                  <Route exact path="/jmlink/startApp/" component={Privacy}/>
                  <Route  path="/preview/:url?/" component={Preview}/>
                  <Route  path="/:page?/" component={()=><Main/>}/>      
                  </Switch>    
            </Router> 
          </MediaQuery>
          <MediaQuery query='(max-device-width:1224px)'>
          <Router history = {browserHistory}>
                <Switch>
                  <Route exact path="/" component={()=><Main/>}/>
                  <Route exact path="/privacy/" component={Privacy}/>
                  <Route  path="/agreements/" component={Agreements}/>
                  <Route  path="/video/:prefix?/" component={AppVideo}/>
                  <Route  path="/dance/agreements/" component={DAgreements}/>
                  <Route path="/dance/privacy/" component={DPrivacy}/>
                  <Route  path="/download/:idcode?/" component={Download}/>
                  <Route  path="/share/:idcode?/" component={Share}/>
                  <Route exact path="/jmlink/startApp/" component={Privacy}/>
                  <Route  path="/preview/:url?/" component={Preview}/>
                  <Route  path="/:page?/" component={()=><Main/>}/>      
                  </Switch>    
            </Router> 
          </MediaQuery> 
          </div>
  }
}